/*@flow*/
import { useContext } from 'react';
import FormContext from '../context';
import getFieldInfo from '../util/getFieldInfo';
import type { PathT } from '../types';

export default function useField<V: any>(path: PathT) {
  const ctx = useContext(FormContext);
  const { type, value } = ctx.state;
  return getFieldInfo<V>(path, type, value);
}
